export default {
  showPassword: 'Show password',
  hidePassword: 'Hide password',
} as const;
